import { Moon, Sun } from "lucide-react";
import { useEffect, useState } from "react";
import { Button, cn } from "../ui/index.js";

/** Moon/sun theme toggle. On click <html data-theme> + localStorage
 *  `livcg-theme` are written. The initial state is read from the data-theme set
 *  by the bootstrap script (no FOUC — the index.html <head> script). */
type Theme = "light" | "dark";
const KEY = "livcg-theme";

function currentTheme(): Theme {
  return document.documentElement.dataset.theme === "light" ? "light" : "dark";
}

export function ThemeToggle({ className }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(currentTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const toggle = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* private mode — ignore */
    }
  };

  return (
    <Button
      variant="secondary"
      size="md"
      iconOnly
      aria-label="Temani almashtirish"
      title={theme === "dark" ? "Yorug' temaga o'tish" : "Qorong'i temaga o'tish"}
      onClick={toggle}
      className={cn("text-ink-muted", className)}
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}
